export default {
  apiUrl: process.env.REACT_APP_API_URL,
  socketUrl: process.env.REACT_APP_SOCKET_URL,
  scooterUrl: process.env.REACT_APP_SCOOTER_URL,
  localeUrl: process.env.REACT_APP_LOCALE_URL,
  accountsUrl: process.env.REACT_APP_ACCOUNTS_URL,
  chargerUrl: process.env.REACT_APP_CHARGERS_URL,
  iPayUrl: process.env.REACT_APP_IPAY_URL,
};



// WEBPACK FOOTER //
// ./src/utils/settings.js